import { render } from "./CreatePatient.vue?vue&type=template&id=5426a85b&scoped=true"
import script from "./CreatePatient.vue?vue&type=script&lang=js"
export * from "./CreatePatient.vue?vue&type=script&lang=js"

import "./CreatePatient.vue?vue&type=style&index=0&id=5426a85b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5426a85b"]])

export default __exports__